import { Flex, VStack } from '@chakra-ui/react';
import { renderError } from 'components/common/ErrorFallback';
import { useCurrentRoute } from 'hooks/utils/useCurrentRoute';
import React, { ReactElement } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppContext } from 'store/AppContext';
import { ModalTarget } from 'types/Modal';
import { RouteType } from 'types/Routes';
import { NavigationBar } from '../NavigationBar/NavigationBarMobile/NavigationBar';
import { TopBar } from '../TopBar/TopBar';

type Props = {
  children: ReactElement;
};
export const MobileLayout = ({ children }: Props): ReactElement => {
  const location = useLocation();
  const { isDropdownOpen } = useAppContext();
  const { routeType, currentRoute } = useCurrentRoute(location);
  const [searchParams] = useSearchParams();
  const viewType = searchParams.get('viewType') || '';
  const isWebview = viewType === 'webview';

  const shouldShowNavbar = routeType === RouteType.PROTECTED && !isWebview;
  const shouldHideTopBar =
    (currentRoute === null && routeType === RouteType.PUBLIC) || isDropdownOpen || isWebview;

  return (
    <Flex
      flexDirection="column"
      bg="background.canvas"
      minHeight="100vh"
      w="full"
      mx="auto"
      position="relative"
    >
      <TopBar isHidden={shouldHideTopBar} />
      <VStack gap={0} flexGrow={1} id={ModalTarget.PAGE_MOBILE} position="relative">
        <ErrorBoundary fallbackRender={renderError}>{children}</ErrorBoundary>
      </VStack>
      {shouldShowNavbar && <NavigationBar />}
    </Flex>
  );
};
